var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import sendAPIRequest from '../../helpers/api/plugNmeetAPI';
import { toast } from 'react-toastify';
import { store } from '../../store';
import { ApproveWaitingUsersReq, CommonResponse, RemoveParticipantReq, } from '../../helpers/proto/plugnmeet_common_api_pb';
const BulkAction = ({ waitingParticipants }) => {
    _react_refresh_temp_2();
    const { t } = useTranslation();
    const approveEveryone = () => {
        waitingParticipants.forEach(async (p) => {
            const body = new ApproveWaitingUsersReq({
                userId: p.userId,
            });
            const r = await sendAPIRequest('waitingRoom/approveUsers', body.toBinary(), false, 'application/protobuf', 'arraybuffer');
            const res = CommonResponse.fromBinary(new Uint8Array(r));
            if (!res.status) {
                toast(t(res.msg), {
                    type: 'error',
                });
            }
        });
    };
    const rejectEveryone = () => {
        const session = store.getState().session;
        const body = new RemoveParticipantReq({
            sid: session.currentRoom.sid,
            roomId: session.currentRoom.room_id,
        });
        waitingParticipants.forEach(async (p) => {
            body.userId = p.userId;
            body.msg = t('notifications.you-have-reject');
            body.blockUser = false;
            const r = await sendAPIRequest('removeParticipant', body.toBinary(), false, 'application/protobuf', 'arraybuffer');
            const res = CommonResponse.fromBinary(new Uint8Array(r));
            if (!res.status) {
                toast(t(res.msg), {
                    type: 'error',
                });
            }
        });
    };
    return (_jsxs("div", { className: "mb-4 flex flex-wrap items-center justify-start", children: [_jsx("button", { onClick: approveEveryone, className: "py-1 px-6 ltr:mr-4 rtl:ml-4 rounded-xl text-white text-sm block transition ease-in bg-primaryColor hover:bg-secondaryColor", children: t('waiting-room.accept-all') }), _jsx("button", { onClick: rejectEveryone, className: "py-1 px-6 rounded-xl text-white text-sm block transition ease-in bg-primaryColor hover:bg-secondaryColor", children: t('waiting-room.reject-all') })] }));
};
_react_refresh_temp_1 = BulkAction;
$RefreshReg$(_react_refresh_temp_1, "BulkAction");
_react_refresh_temp_2(BulkAction, "zlIdU9EjM2llFt74AbE2KsUJXyM=", false, () => [useTranslation]);
export default BulkAction;
